import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import StarProfileRightContent from "./StarCardComponent/StarProfileRightContent/StarProfileRightContent";

import axios from "axios";
import noImage from "../../Assets/Images/settings/no-image.png";
import Icon from "../../Assets/Images/Souvenir/Icons/auction.png";
import AuctionModal from "./StarChat/AuctionModal";
import NodataAvailable from "../Common/NodataAvailable";
import { serverInfo } from "../../App";
import { LocationContext } from "../../CustomHelper/Helper";
import { Markup } from "interweave";

const StarAuction = ({ star_id }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [more, setmore] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [product, setProduct] = useState([]);
  const [modalData, setModalData] = useState("");

  const { paymentCountWithSymbol, payStatus } = useContext(LocationContext);

  useEffect(() => {
    axios.get(`/api/user/getStarAuction/${star_id}`).then((res) => {
      if (res.data.status === 200) {
        setProduct(res.data.product);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/user/liveBidding/auction/${product.id}`).then((res) => {
      if (res.data.status === 200) {
        //setProduct(res.data.bidding);
      }
    });
  }, []);

  const openModal = (data) => {
    setModalShow(true);
    setModalData(data);
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-lg-8 mt-2">
            {product.length > 0 ? (
              product.map((product) => (
                <div className="bg-adrk p-3 card m-3 mb-4 AuctionsA  ">
                  <div className=" row TabMar">
                    <div className="col-md-6">
                      <OwlCarousel
                        items={1}
                        loop
                        autoplay
                        autoplayTimeout={3000}
                        margin={0}
                        dots={false}
                      >
                        <img
                          src={imageCdnUrl + product?.product_image}
                          alt=""
                          className="img-fluid AuctionsImg "
                        />
                      </OwlCarousel>
                    </div>

                    <div className="col-md-6 containerAuc px-3">
                      <div className="w-100">
                        <h3>{product.title}</h3>
                        <p className="text-light ">
                          <Markup
                            content={product?.details.substring(0, 50)}
                          ></Markup>
                        </p>

                        <div className="text-light ">
                          <span className="DollarPrice fw-bold">
                            {paymentCountWithSymbol(product.base_price)}
                          </span>
                          &nbsp;
                        </div>
                        <div className="d-flex mt-2 JerseyAucPro w-100 justify-content-between">
                          <div className="d-flex">
                            <img
                              src={
                                product.star?.image !== null
                                  ? imageCdnUrl + product.star?.image
                                  : noImage
                              }
                              className="AuctionProImg img-fluid"
                              alt="star-profile"
                            />
                            <span className="mx-2 mt-1 SpanAu">
                              <div className="proTextAc">
                                {" "}
                                {product?.star?.first_name}{" "}
                                {product?.star?.last_name}{" "}
                              </div>
                            </span>
                          </div>

                          <div className="BestPrice"> Base Price</div>
                        </div>

                        {payStatus && (
                          <button
                            className="btn bg-warning fw-bold w-100 mt-2 JerseyAucBuy"
                            onClick={() => openModal(product.id)}
                            disabled={
                              new Date().getTime() >
                              new Date(product.bid_to).getTime()
                                ? true
                                : false
                            }
                          >
                            <img
                              src={Icon}
                              alt=""
                              className="mx-2 "
                              height={18}
                            />{" "}
                            Participate
                          </button>
                        )}
                      </div>
                      <AuctionModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        data={modalData}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <NodataAvailable className="mt-5" />
            )}
          </div>

          <div className="col-md-4 abNStar">
            <StarProfileRightContent star_id={star_id} />
          </div>
        </div>
      </div>
    </>
  );
};

export default StarAuction;
